import usePaginatedRegisters from '@/modules/PaginatedRegisters.js'
import { ref } from 'vue'

const users = ref([])
const total_users = ref(0)
const user_filters = ref({})
const loading = ref(false)

export default function useCompanies() {
  const {
    listRegisters,
    get_api_path,
    save_api_path,
    getAllRegisters,
    search_and_paginate_api_path,
    destroy_api_path,
    destroyRegister,
    saveRegister,
    getRegister,
  } = usePaginatedRegisters()

  search_and_paginate_api_path.value = '/api/users/searchAndPaginate'
  get_api_path.value = '/api/users/get/'
  save_api_path.value = '/api/users/storeOrUpdate'
  destroy_api_path.value = '/api/users/destroy/'

  const listUsers = async (page, per_page) => {
    loading.value = true

    return new Promise((resolve, reject) => {
      listRegisters(page, per_page, user_filters.value)
        .then((response) => {
          total_users.value = response.data.meta.total
          users.value = response.data.data
          resolve()
        })
        .catch((error) => {
          console.log(error)
          reject()
        })
        .finally(() => (loading.value = false))
    })
  }

  const destroyUser = async (id, index) => {
    destroyRegister(id).then(() => {
      users.value.splice(index, 1)
    })
  }

  return {
    users,
    total_users,
    user_filters,
    loading,
    listUsers,
    destroyUser,
    getAllUsers: getAllRegisters,
    saveUser: saveRegister,
    getUser: getRegister,
  }
}
